import { useMemo } from 'react';
import { years } from '../../../../Common/Filters/Filters';
import { useServicesChartsDataContext } from './useServicesChartsDataContext';

const useServicesPerYearTotalChart = () => {
    const { chartData, subtitles } = useServicesChartsDataContext();

    const series = useMemo(
        () =>
            subtitles.map((item) => {
                const data = years.map((year) => {
                    const found = chartData.counterYear.find(
                        (counter) => counter.ano_competencia === year
                    );

                    return found
                        ? Number(found.average_permanences).toFixed(0)
                        : 0;
                });

                return {
                    name: item,
                    data
                };
            }),
        [chartData, subtitles]
    );

    return {
        series,
        subtitles: years
    };
};

export default useServicesPerYearTotalChart;
